import { Button } from "@/components/ui/button";
import { DecisionKindEnum } from "@/enum/decision-kind";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Check, X } from "lucide-react";

import { PAYROLL_VOUCHER_LABELS } from "../messages";
import { PayrollVoucher, VoucherDecision } from "../types";
import { BatchDecisionModal } from "./batch-decision-modal";

interface BatchDecisionBarProps {
  selected: PayrollVoucher[];
  onDecideBatch: (
    vouchers: readonly PayrollVoucher[],
    decision: VoucherDecision,
  ) => Promise<void>;
}

const MODAL_TITLE: Record<DecisionKindEnum, string> = {
  [DecisionKindEnum.APPROVE]: PAYROLL_VOUCHER_LABELS.BATCH_APPROVE_TITLE,
  [DecisionKindEnum.REJECT]: PAYROLL_VOUCHER_LABELS.BATCH_REJECT_TITLE,
};

export function BatchDecisionBar({
  selected,
  onDecideBatch,
}: BatchDecisionBarProps): JSX.Element {
  const { handleModal } = useDialogModal();

  const open = (kind: DecisionKindEnum): void => {
    handleModal({
      isOpen: true,
      title: MODAL_TITLE[kind],
      element: (
        <BatchDecisionModal
          selected={selected}
          kind={kind}
          onConfirm={onDecideBatch}
        />
      ),
    });
  };

  return (
    <div className="sticky top-0 z-20 mb-3 rounded-xl border bg-[#F9FBFC] px-4 py-3 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <span className="text-sm text-[#613F4F]">
          {PAYROLL_VOUCHER_LABELS.BATCH_SELECTED(selected.length)}
        </span>

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            className="h-8 border-green-300 text-green-700 hover:border-green-700 hover:bg-green-700 hover:text-white"
            onClick={() => open(DecisionKindEnum.APPROVE)}
          >
            <Check className="mr-2 h-4 w-4" />
            {PAYROLL_VOUCHER_LABELS.BATCH_APPROVE}
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="h-8 border-red-300 text-red-700 hover:border-red-700 hover:bg-red-700 hover:text-white"
            onClick={() => open(DecisionKindEnum.REJECT)}
          >
            <X className="mr-2 h-4 w-4" />
            {PAYROLL_VOUCHER_LABELS.BATCH_REJECT}
          </Button>
        </div>
      </div>
    </div>
  );
}
